const Firebaseconfig = {
  "apiKey": "AIzaSyAOawiYWugvvR11J5QrlbE7gXJDhV32JFE",
  "authDomain": "ds-demo-server.firebaseapp.com",
  "databaseURL": "https://aws-ad-platform.firebaseio.com",
  "projectId": "ds-demo-server",
  "storageBucket": "ds-demo-server.appspot.com",
  "messagingSenderId": "1042328821721",
  "captchaSiteKey": "",
  "appId": "1:1042328821721:web:2007157d0e8192aea7c3c8",
  "measurementId": "G-RXWYJWDM5C"
};

const CommProtocol = {
  'sslType': true
}

const StompConfig = {
  "url": "",
  "loginName": "",
  "passcode": ""
}

export { Firebaseconfig, CommProtocol, StompConfig }


// WEBPACK FOOTER //
// ./firebase.ts